<div class="row align-items-center" *ngIf="!(isReadOnly || isCaseApproved)">
  <div class="col-md-12 d-flex justify-content-end">
    <button class="btn btn-info mx-2" (click)="openPaymentReceiverPopup()">
      {{ 'case-payment-receiver.add-button' | translate }}
    </button>
    <button class="btn btn-info" (click)="openFormPopup()">
      {{ "case.payment-informations.add-button" | translate }}
    </button>
  </div>
</div>
<hr/>

@if (payments.length > 0) {

  <div class="transaction-list">
    <div class="list-header">
      <span>{{ "common.id" | translate }}</span>
      <span>{{ "case.payment-informations.details" | translate }}</span>
      <span>{{ "case.payment-informations.instituation" | translate }}</span>
      <span>{{ "case.payment-informations.staff" | translate }}</span>
      <span>{{ "case.payment-informations.total" | translate }}</span>
      <span>{{ "case.payment-informations.rate-of-exchange" | translate }}</span>
      <span>{{ "case.payment-informations.tl-total" | translate }}</span>
      <span></span>
    </div>

    <div class="table-body">
      <div
        *ngFor="let payment of payments; trackBy: trackByFn"
        class="transaction-row" [class.digital-payment]="payment?.paymentType?.label === 'Sanal Pos (Sipay)'"
      >
        <div>{{ payment?.id }}</div>
        <div class="transaction-info">
          <div class="transaction-type">
            {{ payment?.paymentType?.label || "Belirtilmemiş" }}
          </div>
          <div class="transaction-date">
            {{ payment?.paymentDate | dateFormat }}
          </div>
          <div class="provision-no" *ngIf="payment?.provisionNo">
            <small
            >{{ "case.payment-informations.provision-no" | translate }}:
              {{ payment?.provisionNo }}</small
            >
          </div>
          <span *ngIf="payment?.paymentType?.label === 'Sanal Pos (Sipay)'">
          {{ payment.payed ? '🟢' : '🔴' }}
            {{ "case.payment-informations." + (payment.payed ? 'payed' : 'not-payed') | translate }}
        </span>
        </div>

        <div class="institution-name">
          {{ payment?.institution?.label || "-" }}
        </div>

        <div class="staff-name">
          {{ payment?.staff?.label || "-" }}
        </div>

        <div class="amount-info">
          <div class="amount">
            {{ payment?.total | number : "1.2-2" }}
            {{ payment?.exchangeType?.label || "TL" }}
          </div>
        </div>

        <div class="exchange-rate">
          {{ payment?.rateOfExchange | number : "1.2-2" }}
        </div>

        <div class="total-amount">
        <span class="total-badge">
          {{ payment?.totalTL | number : "1.2-2" }} TL
        </span>
        </div>

        <div class="action-buttons">

          <button
            type="button"
            class="btn btn-warning btn-icon-xxs"
            (click)="openFormPopup(payment)"
            *ngIf="!(isReadOnly || isCaseApproved || payment.payed)">
            <i class="fas fa-pencil-alt"></i>
          </button>

          <button
            type="button"
            class="btn btn-danger btn-icon-xxs"
            (click)="deletePayment(payment)"
            *ngIf="!(isReadOnly || isCaseApproved || payment.payed)">
            <i class="fas fa-trash-alt"></i>
          </button>
        </div>

        <div *ngIf="payment?.paymentType?.label === 'Sanal Pos (Sipay)'" class="digital-payment-row">

          <i class="fi fi-sr-payment-pos" style="font-size: 32px;margin-bottom: -10px;"></i>

          <span [class.sms-sended]="payment.sipaySmsSended">
            {{ (payment.sipaySmsSended ? 'case.payment-informations.digital-payment.sms-sended' : 'case.payment-informations.digital-payment.sms-waiting') | translate }}
        </span>

          <span>
          {{ ("case.payment-informations.digital-payment.sipay-statuses." + (payment.sipayStatus ? payment.sipayStatus : 'null')) | translate }}
        </span>

          <app-payment-button *ngIf="!(isReadOnly || isCaseApproved || payment.payed)" [paymentId]="payment.id"
                              [uuid]="payment.uuid"></app-payment-button>
        </div>
      </div>
    </div>
  </div>

} @else {
  <app-core-info-messages
    type="info"
    [closable]="true"
    [message]="'case.payment-informations.no-payment' | translate"
  ></app-core-info-messages>
}

<div class="fixed-footer">
  <div class="footer-header" (click)="toggleFooter()" role="button"  tabindex="-1">
    <div class="footer-left">{{ 'case.payment-informations.fixed-footer-header' | translate }}</div>
    <div class="footer-info" *ngIf="!isFooterExpanded">
      <div class="footer-total">
        <span class="footer-total-label"
        >{{ "case.payment-informations.total-must-paid" | translate }}:</span
        >
        <span class="footer-total-value text-center">{{
            detailInfo?.totalMustPaid != null ? (detailInfo.totalMustPaid | numberComma) : "-"
          }} ₺</span>
      </div>
      <div class="footer-total">
        <span class="footer-total-label"
        >{{ "case.payment-informations.paid" | translate }}:</span
        >
        <span class="footer-total-value text-center">{{
            detailInfo?.paid != null ? (detailInfo.paid | numberComma) : "-"
          }} ₺</span>
      </div>
      <div class="footer-total">
        <span class="footer-total-label"
        > {{ "case.payment-informations.invoiced-amount" | translate }}:</span
        >
        <span class="footer-total-value">
        {{
            detailInfo?.invoicedAmount != null
              ? (detailInfo.invoicedAmount | numberComma)
              : "-"
          }}
          ₺
        </span>
      </div>

    </div>
    <div class="footer-chevron-container">
      <span class="footer-chevron" [class.rotated]="isFooterExpanded">▼</span>
    </div>
  </div>

  <div class="footer-content" [class.expanded]="isFooterExpanded">
    <div class="footer-details">
      <div id="summary-price">
        <div class="summary-item">
          <span class="summary-label">
            {{ "case.payment-informations.total-must-paid" | translate }}:</span
          >
          <span class="summary-value"
          >{{
              detailInfo?.totalMustPaid != null
                ? (detailInfo.totalMustPaid | numberComma)
                : "-"
            }} ₺</span
          >
        </div>
        <div class="summary-item">
          <span class="summary-label">
            {{ "case.payment-informations.paid" | translate }}:</span
          >
          <span class="summary-value paid"
          >{{
              detailInfo?.paid != null ? (detailInfo.paid | numberComma) : "-"
            }}
            ₺</span
          >
        </div>
        <div class="summary-item">
          <span class="summary-label">
            {{ "case.payment-informations.must-paid" | translate }}:</span
          >
          <span class="summary-value mustPaid"
          >{{
              detailInfo?.mustPaid != null
                ? (detailInfo.mustPaid | numberComma)
                : "-"
            }}
            ₺</span
          >
        </div>
      </div>

      <div id="summary-price summary-price-style">
        <div class="summary-item">
          <span class="summary-label">
            {{
              "case.payment-informations.total-invoiced-amount" | translate
            }}:</span
          >
          <span class="summary-value">
            {{
              detailInfo?.totalInvoicedAmount != null
                ? (detailInfo.totalInvoicedAmount | numberComma)
                : "-"
            }}
            ₺</span
          >
        </div>
        <div class="summary-item">
          <span class="summary-label">
            {{ "case.payment-informations.invoiced-amount" | translate }}:</span
          >
          <span class="summary-value paid"
          >{{
              detailInfo?.invoicedAmount != null
                ? (detailInfo.invoicedAmount | numberComma)
                : "-"
            }}
            ₺</span
          >
        </div>
        <div class="summary-item">
          <span class="summary-label">
            {{
              "case.payment-informations.must-invoiced-amount" | translate
            }}:</span
          >
          <span class="summary-value mustPaid"
          >{{
              detailInfo?.mustInvoicedAmount != null
                ? (detailInfo.mustInvoicedAmount | numberComma)
                : "-"
            }}
            ₺</span
          >
        </div>
      </div>
    </div>
  </div>
</div>

<app-case-payment-form
  (saveOn)="onSave($event)"
  [suggestedAmount]="(detailInfo.totalMustPaid ?? 0) - (detailInfo.paid ?? 0)"
  #paymentForm
></app-case-payment-form>

<app-create-payment-receiver-popup #paymentReceiver></app-create-payment-receiver-popup>
